var rules = {
    required : function(key, map){
        var val = innerParseValue(key, map);
        ///return !!val;
        return val === 0 || !!val;
    },
    number : function(key, map){
        var val = innerParseValue(key, map);
         // isNaN()函数 把空串 空格 以及NUll 按照0来处理 所以先去除
        if(val === "" || val ==null){
            return true;
        }
        if(!isNaN(val)){
            return true;
        }else{
            return false;
        }
    },
    port : function(key, map){
        var val = innerParseValue(key, map); 
        if(rules.number(val)){
            val = Number(val);
            return val >= 0 && val <= 65535;
        }
        return false;
    },
    email : function(key, map){
        var val = innerParseValue(key, map); 
        var myReg=/^[a-zA-Z0-9_-]+@([a-zA-Z0-9]+\.)+(com|cn|net|org)$/;
        if(val === "" || val ==null){
            return true;
        }
    　　return myReg.test(val);
    },
    phone : function(key, map){
        var val = innerParseValue(key, map); 
        var myreg=/^[1][3,4,5,7,8,9][0-9]{9}$/;
        if(val === "" || val ==null){
            return true;
        }
        return myreg.test(val);
    },
    phoneortel : function(key, map){
        
    },
    ip : function(key, map){
        var val = innerParseValue(key, map); 
        var myReg=/^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/;
    　　return myReg.test(val);
    },
    sfzh : function(key, map){
        var val = innerParseValue(key, map); 
        var myReg=/^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        return myReg.test(val);
    },
    //控制输入长度 limit：限制的长度
    charlength : function(key, map, obj){
        var val = innerParseValue(key, map);
        var limit = obj.limit;
        if(val && val.length > limit){
            return false;
        }else{
            return true;
        }
    },
}

function innerParseValue(key, map){
    var multiObjAttrs = key.split(".");
    if(multiObjAttrs.length == 1) {
        return map[key];
    } else {
        var result = map;
        for(var i = 0 ; i < multiObjAttrs.length; i++) {
            var objAttr = multiObjAttrs[i];
            var arrFlagStart = objAttr.indexOf("[");
            var arrFlagEnd = objAttr.indexOf("]");
            // 处理 attr1.attr2[0].attr3 这种情况
            if(arrFlagStart > 0 && arrFlagEnd > 0) {
                if(arrFlagEnd == objAttr.length - 1) {
                    var arrIndex = objAttr.substring(arrFlagStart + 1, arrFlagEnd);
                    try {
                        arrIndex = Number(arrIndex);
                    } catch(e){}
                    if(typeof arrIndex == 'number'){
                        var arrAttr = objAttr.substring(0, arrFlagStart);
                        result = result[arrAttr];
                        result = result[arrIndex];
                        continue;
                    }
                }
            }
            result = result[objAttr];
        }
        return result;
    }
}



export default {
    // 翻译方法
    getRuleMethod : function(ruleName){
        return rules[ruleName];
    },
}


// WEBPACK FOOTER //
// ./src/support/rule.js